import type { EcomData, EcomDataMultiple, EcomProduct } from '~/constants/types/product';
import { useConfigStore } from '~/store/config';

export default function useProductService() {
  const { centraPost, centraPut } = useApiFetch();
  const config = useConfigStore();
  const fetchProduct = async(ecomId: number | string, wpId: number | null = null) => {
    const contentData = null;
    if (wpId) {
      // @todo - add wp data? - no product uses it
    }
    if (import.meta.server) {
      await centraPut('/countries/' + config.market.country);
    }
    const product = await centraPost<EcomData>(`/products/${ecomId}`);
    if (product) {
      return { ecomData: product.product, contentData };
    }
    throw new Error();
  };

  const fetchProducts = async(filters: object) => {
    filters = {
      ...filters,
      var_channel: ['Webshop'],
    };
    const body = {
      ...filters,
      relatedProducts: true,
    };
    if (import.meta.server) {
      await centraPut('/countries/' + config.market.country);
    }
    const data = await centraPost<EcomDataMultiple>('/products', body);
    if (data) {
      const filteredProducts = data.products.filter((p: EcomProduct) => p.name);
      return { products: filteredProducts, data };
    } else {
      console.error('Couldnt load products');
    }
  };

  return {
    fetchProduct,
    fetchProducts,
  };
}
